module.exports = __webpack_public_path__ + "img/body-2-lg.d1c85841.png";